// Portal completo: el cascarón con su menú, o la explicación de por qué no hay nada que mostrar.
//
// Los permisos vacíos tienen TRES causas y solo una es del usuario: el perfil todavía en vuelo, el
// perfil que no se pudo leer, y la cuenta que de verdad no tiene entrada a este portal.
import { type ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { AppShell, type AppShellNavGroup } from './AppShell';
import { hasPortalAccess } from './navAccess';
import { PortalAccessDenied } from './PortalAccessDenied';
import { ProfileGate } from './ProfileGate';

export function PortalShell({
    title,
    nav,
    actions,
    children,
}: {
    title: string;
    nav: AppShellNavGroup[];
    actions?: ReactNode;
    children: ReactNode;
}) {
    return (
        <ProfileGate>
            <PortalContent title={title} nav={nav} actions={actions}>
                {children}
            </PortalContent>
        </ProfileGate>
    );
}

function PortalContent({
    title,
    nav,
    actions,
    children,
}: {
    title: string;
    nav: AppShellNavGroup[];
    actions?: ReactNode;
    children: ReactNode;
}) {
    const { hasPermission } = useAuth();
    if (!hasPortalAccess(nav, hasPermission)) return <PortalAccessDenied portalTitle={title} />;
    return (
        <AppShell title={title} nav={nav} actions={actions}>
            {children}
        </AppShell>
    );
}
